import React, {useEffect, useState} from "react";
import teacherService from "../../../../services/teacherService";
import {ChildData, OwnScholarsResponse} from "../../../utilities/constants";
import CurrentDayDiary from "../../../shared/admin/currentDayDiary/currentDayDiary";
import {Accordion} from "react-bootstrap";
import Loader from "../../../shared/admin/loader/loader";


function CompilaRegistro(){
    const [ownScholars, setOwnScholars] = useState<ChildData[]>()
    const [notification, setNotification] = useState<{ type: string; message: string; } | null>(null);
    const [loading, setLoading] = useState(true);
    // Bambini la cui scheda è stata aperta almeno una volta: evita di far partire diario e immagini
    // di tutti i bambini insieme al caricamento della pagina, una per bambino solo quando serve davvero
    const [loadedScholars, setLoadedScholars] = useState<Set<string>>(new Set());

    useEffect(() => {
        setLoading(true);
        // Chiamiamo la funzione per ottenere gli alunni dell'insegnante corrente
        fetchOwnScholars();
    }, []);

    // Definiamo la funzione per ottenere gli alunni dell'insegnante corrente
    const fetchOwnScholars = async () => {
        try {
            // Eseguiamo la chiamata API per ottenere gli alunni dell'insegnante
            const response: OwnScholarsResponse = await teacherService.getChildren({
                paginate: 30,
                sortBy: 'last_name',
                sort: 'DESC',
                searchQuery: '',
                includeInactive: false
            });
            console.log(response.data); // Stampa la risposta della chiamata API
            setOwnScholars(response.data)

        } catch (error) {
            console.error('Errore durante il recupero degli alunni dell\'insegnante:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleNotification = (notificationData: React.SetStateAction<{ type: string; message: string; } | null>) => {
        setNotification(notificationData);
        setTimeout(() => {
            setNotification(null); // Nascondi la notifica dopo 5 secondi
        }, 5000);
    };

    // Segna il bambino come "aperto" la prima volta che la sua scheda viene espansa
    const handleAccordionSelect = (eventKey: string | string[] | null | undefined) => {
        if (eventKey && typeof eventKey === "string") {
            setLoadedScholars(prev => new Set(prev).add(eventKey));
        }
    };

    return(
        <>
            {loading && <Loader />}
            <Accordion onSelect={handleAccordionSelect}>
                {
                    ownScholars?.map((scholar) => (
                        <CurrentDayDiary
                            eventKey = {scholar.id}
                            title = {scholar.first_name + " " + scholar.last_name}
                            onNotification={handleNotification}
                            shouldLoad={loadedScholars.has(scholar.id)}
                        >
                        </CurrentDayDiary>
                    ))
                }
            </Accordion>
            {notification && (
                <div className={`alert alert-${notification.type} alert-center`}
                     role="alert"
                     onClick={() => setNotification(null)}
                     style={{ cursor: 'pointer' }}>
                    {notification.message} {/* Renderizza solo il messaggio */}
                </div>
            )}
        </>
    )
}
export default CompilaRegistro;